import { ComponentRef, RefObject, useCallback } from 'react';

import { AbsenceWarningModal } from 'shared/presentation/components/molecules';
import { TAbsenceWarningFlow } from 'shared/domain/entities';
import { ABSENCE_WARNING_CHANNEL } from 'shared/presentation/constants';
import { useActiveCustomer } from 'shared/presentation/contexts';

type TAbsenceWarningModalRef = ComponentRef<typeof AbsenceWarningModal>;

export default function useAbsenceWarningGate(
  ref: RefObject<TAbsenceWarningModalRef>,
) {
  const { customer } = useActiveCustomer();

  return useCallback(
    async (flow: TAbsenceWarningFlow, scheduleId?: number) => {
      const canProceed = await ref.current?.evaluate({
        customerId: Number(customer?.id),
        scheduleId,
        channel: ABSENCE_WARNING_CHANNEL,
        flow,
      });

      return canProceed !== false;
    },
    [customer, ref],
  );
}
